import { validateApp } from './validateStep/validateApp.js';
import { validateFlowControl } from './validateStep/validateFlowControl.js';
import { validateFolder } from './validateStep/validateFolder.js';
import { validateGroupResults } from './validateStep/validateGroupResults.js';
import { validateHttpRequest } from './validateStep/validateHttpRequest.js';
import { validateIfElse } from './validateStep/validateIfElse.js';
import { validateIterate } from './validateStep/validateIterate.js';
import { validateMap } from './validateStep/validateMap.js';
import validateRunWorkflow from './validateStep/validateRunWorkflow.js';
import { validateSchedule } from './validateStep/validateSchedule.js';
import { validateTransform } from './validateStep/validateTransform.js';

// Todo: the parent validateStep function should evaluate all arguments and pass this into the individual validation files in the future.
export const validateStep = async ({ workflow, app, step, credential }) => {
  const slug = app?.slug;
  const stepRan = step?.meta?.ran;
  const status = stepRan ? 'invalid' : 'setup';

  if (slug === 'ifElse') {
    return await validateIfElse({ step, status });
  }

  if (slug === 'transform') {
    return await validateTransform({ step, workflow, status });
  }

  if (slug === 'map') {
    return validateMap({ step, status });
  }

  if (slug === 'iterate') {
    return validateIterate({ step, status });
  }

  if (slug === 'schedule') {
    return validateSchedule({ step });
  }

  if (slug === 'flowControl') {
    return await validateFlowControl({ step, status });
  }

  if (slug === 'folder') {
    return validateFolder({ step, workflow });
  }

  if (slug === 'runWorkflow') {
    return validateRunWorkflow({ step });
  }

  if (slug === 'httpRequest') {
    return await validateHttpRequest({ step, status });
  }

  if (slug === 'groupResults') {
    return validateGroupResults({ step, status });
  }

  const specialApps = ['wait', 'continue', 'webhook', 'memory', 'break'];
  if (specialApps.includes(slug)) {
    return { status: 'valid' };
  }

  return await validateApp({ workflow, app, step, credential, status });
};
